// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"c9ec2f9e","130":"1f4fef71","146":"f677fb38","950":"cdf92c38"}[chunkId] + ".chunk.js";
};